export const assetPaths = {
    images: [
        { name: 'bkgBuildings.png', path: 'assets/images/bkgBuildings.png' },
        { name: 'bkgTrees.png', path: 'assets/images/bkgTrees.png' },
        { name: 'bush.png', path: 'assets/images/bush.png' },
        { name: 'sky.png', path: 'assets/images/sky.png' },
        { name: 'fog.png', path: 'assets/images/fog.png' },
        {
            name: 'smallForegroundTrees.png',
            path: 'assets/images/smallForegroundTrees.png',
        },
        {
            name: 'smallFrontTrees.png',
            path: 'assets/images/smallFrontTrees.png',
        },
    ],
    spines: [
        {
            key: 'Monkey',
            jsonURL: 'assets/spines/Monkey.json',
            atlasURL: 'assets/spines/Monkey.atlas',
            preMultipliedAlpha: true,
        },

        {
            key: 'Vine',
            jsonURL: 'assets/spines/Vine.json',
            atlasURL: 'assets/spines/Vine.atlas',
            preMultipliedAlpha: true,
        },
        {
            key: 'eagle_spine',
            jsonURL: 'assets/spines/eagle_spine.json',
            atlasURL: 'assets/spines/eagle_spine.atlas',
            preMultipliedAlpha: true,
        },
        {
            key: 'chips',
            jsonURL: 'assets/spines/chips.json',
            atlasURL: 'assets/spines/chips.atlas',
            preMultipliedAlpha: true,
        },
        {
            key: 'Glow',
            jsonURL: 'assets/spines/Glow.json',
            atlasURL: 'assets/spines/Glow.atlas',
            preMultipliedAlpha: true,
        },
        {
            key: 'Suits',
            jsonURL: 'assets/spines/Suits.json',
            atlasURL: 'assets/spines/Suits.atlas',
            preMultipliedAlpha: true,
        },
        {
            key: 'vfx_GrabParticles',
            jsonURL: 'assets/spines/vfx_GrabParticles.json',
            atlasURL: 'assets/spines/vfx_GrabParticles.atlas',
            preMultipliedAlpha: true,
        },
    ],
    atlases: [
        {
            name: 'game',
            json: 'assets/atlases/game.json',
            png: 'assets/atlases/game.png',
        },
        {
            name: 'trees',
            json: 'assets/atlases/trees.json',
            png: 'assets/atlases/trees.png',
        },
    ],
};
